import React from 'react';
import PageContainer from '../components/common/PageContainer';
import Layout from '../components/common/Layout';
import EdmDashboard from '../components/screens/dashboard/EdmDashboard';
import RegulatorDashboard from '../components/screens/dashboard/RegulatorDashboard';
import { userCats } from '../helpers/appstate';
import ConsultantDashboardScreen from '../components/screens/dashboard/ConsultantDashboardScreen';
import PersonelDashboardScreen from '../components/screens/dashboard/PersonelDashboardScreen';

export default function Dashboard(props) {
  const userCategory = props.userCategory;
  return (
    <Layout headerTitle="Dashboard">
      <PageContainer id="dashboard">
        {userCategory === userCats.EDM && <EdmDashboard />}
        {userCategory === userCats.REGULATOR && <RegulatorDashboard />}
        {userCategory === userCats.CONSULTANT && <ConsultantDashboardScreen props={props} />}
        {userCategory === userCats.PERSONNEL && <PersonelDashboardScreen props={props} />}
      </PageContainer>
    </Layout>
  );
}
